module.exports = __webpack_public_path__ + "static/media/løgn.81d7f983.m4a";